import styled from 'styled-components';
import { color, fontWeight, screen, spacing } from '../../../../theme';
import ButtonLink from 'components/shared/ButtonLink.styled';

export const StyledPagination = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('xs')};
  padding-top: ${spacing('xl3')};
  padding-bottom: 0;
`;

export const StyledEllipsis = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${screen('mdMax')}) {
    display: none;
  }
`;

export const StyledButtonLink = styled(ButtonLink)<{ $isActive?: boolean }>`
  border-radius: 0;
  border: none;
  border-bottom: 2px solid
    ${({ $isActive }) => ($isActive ? color('emerald_500') : 'transparent')};

  font-weight: ${fontWeight('medium')};
`;
